<section class="hero">
    <video autoplay muted loop class="video-background">
        <source src="https://www.dickerdata.com.au/hubfs/windows-11/AUS-DDA-750%20%20LP%20Header-2.mp4" type="video/mp4">
    </video>
    <div *ngIf="!laodingCongratulation">
        <div class="video-content" style="transform: translateY(-200%);">
            <img src="https://www.dickerdata.com.au/hubfs/windows-11/DD%20Logo.png" style="width: 100%; max-width: 120px; height: 100%; margin-bottom: 20px;">
            <h2 class="video-heading-style">Windows 11 Readiness Report</h2>
            <p>Based on the data you provided, we found the following:</p>
            <div  *ngIf="!laodingCongratulation" ><button class="detected-btn">{{totalDevices}}  Devices Detected</button></div>
        </div>
    </div>

    <div *ngIf="laodingCongratulation">
        <div class="video-content" style="transform: translateY(-300%);">
            <img src="https://www.dickerdata.com.au/hubfs/windows-11/DD%20Logo.png" style="width: 100%; max-width: 120px; height: 100%; margin-bottom: 20px;">
            <h2 class="video-heading-style">Windows 11 Readiness Report</h2>
            <p>Based on the data you provided, we found the following:</p>
            <div  *ngIf="!laodingCongratulation" ><button class="detected-btn">{{totalDevices}}  Devices Detected</button></div>
        </div>
    </div>

</section>

<section class="summary">

    <div  *ngIf="!laodingCongratulation" class="summary-container">
        <div class="inner-summary-container" >
            <div class="top-progress-container-outer">
                <div class="top-progress-container">
                    <mat-progress-spinner class="custom-spinner" style="position: absolute;" mode="determinate" [value]=100 [strokeWidth]=12 [diameter]=160>
                    </mat-progress-spinner>
                    <mat-progress-spinner class="mat-progress-spinner-green" mode="determinate" [value]="getPercentage(upgradeEligibility0)" diameter="160"
                        strokeWidth="12"> 
                        
                    </mat-progress-spinner>
                    <div class="progress-text">{{upgradeEligibility0}} 
                        <br><span class="progress-text-devices">Devices</span>
                        <br><div class="progress-text-percentage" style="display: flex; align-items: center; justify-content: center;">{{getPercentage(upgradeEligibility0)}}%</div>
                    </div>
                    <p class="top-circle-text">Devices already on<br> Windows 11</p>
                </div>
            </div>
            <div class="summary-content">
                <p>
                    We have identified that <strong style="font-weight: bold">{{upgradeEligibility2}} of your devices</strong> are ineligible to upgrade to Windows 11, this means you need to act now to replace these devices or protect them with Extended Security Updates (ESU).
                </p>
                <p class="action">
                    <strong style="font-weight: bold">Speak to your customer, or your technical team to identify these devices and to arrange a thorough investigation.</strong>
                </p>
            </div>
        </div>
        <div class="summary-buttons">
            <button class="btn outline">Learn More</button>
            <button class="btn filled">Act Now</button>
            <button class="btn outline">Not Ready to Upgrade?</button>
        </div>
        <div class="stats">
            <div class="stat-item">
                <div class="progress-container">
                    <mat-progress-spinner class="custom-spinner" style="position: absolute;" mode="determinate" [value]=100 [strokeWidth]=12 [diameter]=120>
                    </mat-progress-spinner>
                    <mat-progress-spinner class="mat-progress-spinner-orange" mode="determinate" [value]="getPercentage(upgradeEligibility1)" diameter="120"
                        strokeWidth="12"> 
                    </mat-progress-spinner>
                    <div class="progress-text-container">
                        <div class="bottom-progress-text">{{upgradeEligibility1}} 
                            <br><span class="bottom-progress-text-devices">Devices</span>
                            <br><div class="bottom-progress-text-percentage" style="display: flex; align-items: center; justify-content: center;  color: rgba(217, 119, 6, 1);">{{getPercentage(upgradeEligibility1)}}%</div>
                        </div>
                    </div>
                </div>
                <p class="circle-text">Further investigation <br>required</p>
            </div>
            <div class="stat-item">
                <div class="progress-container">
                    <mat-progress-spinner class="custom-spinner" style="position: absolute;" mode="determinate" [value]=100 [strokeWidth]=12 [diameter]=120>
                    </mat-progress-spinner>
                    <mat-progress-spinner class="mat-progress-spinner-lightgreen" mode="determinate" [value]="getPercentage(upgradeEligibility3)" diameter="120"
                        strokeWidth="12"> 
                    </mat-progress-spinner>
                    <div class="progress-text-container">
                        <div class="bottom-progress-text">{{upgradeEligibility3}} 
                            <br><span class="bottom-progress-text-devices">Devices</span>
                            <br><div class="bottom-progress-text-percentage" style="display: flex; align-items: center; justify-content: center; color:rgba(173, 194, 15, 1);">{{getPercentage(upgradeEligibility3)}}%</div>
                        </div>
                    </div>

                </div>
                <p class="circle-text">Capable to upgrade to<br> Windows 11</p>
            </div>
            <div class="stat-item">
                <div class="progress-container">
                    <mat-progress-spinner class="custom-spinner" style="position: absolute;" mode="determinate" [value]=100 [strokeWidth]=12 [diameter]=120>
                    </mat-progress-spinner>
                    <mat-progress-spinner class="mat-progress-spinner-red" mode="determinate" [value]="getPercentage(upgradeEligibility2)" diameter="120"
                        strokeWidth="12"> 
                    </mat-progress-spinner>
                    <div class="progress-text-container">
                        <div class="bottom-progress-text">{{upgradeEligibility2}} 
                            <br><span class="bottom-progress-text-devices">Devices</span>
                            <br><div class="bottom-progress-text-percentage" style="display: flex; align-items: center; justify-content: center; color:rgba(194, 0, 71, 1);">{{getPercentage(upgradeEligibility2)}}%</div>
                        </div>
                    </div>
                </div>
                <p class="circle-text">Not eligible for<br> Upgrade</p>
            </div>

            <div class="report-button-container">        
            <div class="report-button">
                <button class="center-button" (click)="navigateToReportExtract()">Export Your Windows 11 Readiness Report</button>
            </div>
            <p class="bottom-font">*​This report is a summary of the devices within your organisation and the compatibility of those regarding Windows 11. The report is designed to help you plan for October 2025 when Windows 10 is no longer supported. Dicker Data does not guarantee the results provided in your Windows 11 Readiness Assessment. Output from this tool is designed to be an indicative guide to assist technology partners in educating their end-customers in regards to Windows 10 End of Support.</p>
            </div>  
        </div>
    </div> 
    

    <div  *ngIf="laodingCongratulation" class="summary-container">
        <div>
            <div class="inner-summary-container">
                <div class="top-progress-container-outer">
                    <div class="top-progress-container">
                        <mat-progress-spinner class="custom-spinner" style="position: absolute;" mode="determinate" [value]=100 [strokeWidth]=12 [diameter]=160>
                        </mat-progress-spinner>
                        <mat-progress-spinner class="mat-progress-spinner-green" mode="determinate" [value]="getPercentage(upgradeEligibility0)" diameter="160"
                            strokeWidth="12"> 
                            <div class="progress-text">{{getPercentage(upgradeEligibility3)}}%</div>
                        </mat-progress-spinner>
                        <span class="congratulation-text">
                            <img src="https://www.dickerdata.com.au/hubfs/windows-11/green-tick.gif" alt="Congratulations">
                        </span>
                    </div>
                </div>
                <div class="summary-content">
                    <h1>Congratulations!</h1>
                    <!-- <button class="zero-btn">{{totalDevices}} Devices Detected</button> -->
                    <button class="zero-btn">Zero Devices Detected</button>
                    <p style="font-weight: bold; padding-top: 30px;">We didn't find any devices in your environment that are ineligible to upgrade to Windows 11.</p>
                    <p>However, it's important you still conduct your own thorough investigation to ensure your<br> environment is fully up to date and compliant.</p>
                </div>
            </div>
            <div class="congratulation-button">
                <button class="btnOne">Learn More</button>
                <button class="btnTwo">Not Ready to Upgrade?</button>
            </div>
            <p class="congrt-bottom-font">This report is a summary of the devices within your organisation and the compatibility of those regarding Windows 11. The report is designed to help you plan for October 2025 when Windows 10 is no longer supported.* 
            </p>
        </div>

        <!-- <div *ngIf="notFullyCongratulation">
            <div class="inner-summary-container">
                <div class="top-progress-container-outer">
                    <div class="top-progress-container">
                        <mat-progress-spinner class="custom-spinner" style="position: absolute;" mode="determinate" [value]=100 [strokeWidth]=12 [diameter]=160>
                        </mat-progress-spinner>
                        <mat-progress-spinner class="mat-progress-spinner-green" mode="determinate" [value]="getPercentage(upgradeEligibility0)" diameter="160"
                            strokeWidth="12"> 
                            <div class="progress-text">{{getPercentage(upgradeEligibility3)}}%</div>
                        </mat-progress-spinner>
                    </div>
                </div>
                <div class="summary-content">
                    <h1 style="padding-bottom: 0px !important;">Congratulations!</h1>
                    <p style="font-weight: bold; padding-top: 30px;">We didn't find any devices in your environment that are ineligible to upgrade to Windows 11.</p>
                    <p>However, it's important you still conduct your own thorough investigation to ensure your<br> environment is fully up to date and compliant.</p>
                    <h6>Device breakdown:  Action maybe required.</h6>
                </div>
            </div>
            <div class="stats">
                <div class="stat-item">
                    <div class="progress-container">
                        <mat-progress-spinner class="custom-spinner" style="position: absolute;" mode="determinate" [value]=100 [strokeWidth]=12 [diameter]=120>
                        </mat-progress-spinner>
                        <mat-progress-spinner class="mat-progress-spinner-gr" mode="determinate" [value]="getPercentage(upgradeEligibility3)" diameter="120"
                            strokeWidth="12"> 
                            <div class="progress-text">{{getPercentage(upgradeEligibility3)}}%</div>
                        </mat-progress-spinner>
                    </div>
                    <p class="circle-text">Further investigation <br>required</p>
                </div>
                <div class="stat-item">
                    <div class="progress-container">
                        <mat-progress-spinner class="custom-spinner" style="position: absolute;" mode="determinate" [value]=100 [strokeWidth]=12 [diameter]=120>
                        </mat-progress-spinner>
                        <mat-progress-spinner class="mat-progress-spinner-green" mode="determinate" [value]="getPercentage(upgradeEligibility0)" diameter="120"
                            strokeWidth="12"> 
                            <div class="progress-text">{{getPercentage(upgradeEligibility3)}}%</div>
                        </mat-progress-spinner>
                    </div>
                    <p class="circle-text">Capable to upgrade to<br> Windows 11</p>
                </div>
                <div class="stat-item">
                    <div class="progress-container">
                        <mat-progress-spinner class="custom-spinner" style="position: absolute;" mode="determinate" [value]=100 [strokeWidth]=12 [diameter]=120>
                        </mat-progress-spinner>
                        <mat-progress-spinner class="mat-progress-spinner-lightgreen" mode="determinate" [value]="getPercentage(upgradeEligibility1)" diameter="120"
                            strokeWidth="12"> 
                            <div class="progress-text">{{getPercentage(upgradeEligibility3)}}%</div>
                        </mat-progress-spinner>
                    </div>
                    <p class="circle-text">Devices already on<br> Windows 11</p>
                </div>                     
            </div>
            <div class="congrt-summary-buttons">
                <button class="btn outline">Learn More</button>              
                <button class="btn outline">Not Ready to Upgrade?</button>
                <button class="btn outline">Export Report</button>  
            </div>
            <button class="btn filled summary-center-button">Act Now</button>
            <p class="congrt-bottom-font">*​This report is a summary of the devices within your organisation and the compatibility of those regarding Windows 11. The report is designed to help you plan for October 2025 when Windows 10 is no longer supported. Dicker Data does not guarantee the results provided in your Windows 11 Readiness Assessment. Output from this tool is designed to be an indicative guide to assist technology partners in educating their end-customers in regards to Windows 10 End of Support.
            </p>
        </div> -->
    </div> 

</section>